import styled from 'styled-components';

export const StyledTariffUnitValueWrapperDiv = styled.div`
  vertical-align: top;
  display: inline-block;
  .ant-input-number-disabled {
    background: transparent;
  }
`;

export const StyledHtsInfoDiv = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledHtsDutyParagraph = styled.p`
  display: inline;
  margin-right: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledFormInlineDiv = styled.div`
  display: inline-block;
`;

export const StyledTextParagraph = styled.p`
  margin-bottom: 0;
`;

export const StyledAddAssistButtonDiv = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;
